import React from 'react';
import { NavLink } from 'react-router-dom';

const SB_WIDTH = 220;

const links = [
  { name: 'Dashboard', href: '/admin' },
  { name: 'Usuários', href: '/admin/usuarios' },
  { name: 'Relatórios', href: '/admin/relatorios' },
  { name: 'Configurações', href: '/admin/configuracoes' },
];

export default function Sidebar() {
  return (
    <>
      <style>{`
#sidebar-root{
  position:fixed; left:0; top:0; width:${SB_WIDTH}px; height:100dvh;
  background:#242F3C; color:#fff; z-index:1000;
  display:flex; flex-direction:column; padding-top:32px; overflow-y:auto;
}
@supports not (height: 100dvh){ #sidebar-root{ height:100vh; } }
.sidebar-title{ font-weight:700; font-size:1.1rem; margin:0 0 16px 24px; letter-spacing:.5px; }
.sidebar-link{
  color:#fff; text-decoration:none; display:block; padding:14px 24px;
  font-weight:500; font-size:1rem; border-left:4px solid transparent;
  transition:background .16s, border-color .16s;
}
.sidebar-link:hover{ background:#2A3442; }
.sidebar-link.active{ background:#232A34; border-left-color:#F36611; }

@media (max-width:992px){ #sidebar-root{ display:none !important; } }
@media print{ #sidebar-root{ display:none !important; } }
      `}</style>

      <aside id="sidebar-root" role="navigation" aria-label="Navegação administrativa">
        <div className="sidebar-title">Painel Admin</div>
        {links.map(l => (
          <NavLink
            key={l.href}
            to={l.href}
            className={({isActive}) => 'sidebar-link' + (isActive ? ' active' : '')}
          >
            {l.name}
          </NavLink>
        ))}
      </aside>
    </>
  );
}
